<template>
  <footer>
    <div class="container">
      <router-link to="/">
        <img src="../assets/logo-gray.png" width="373" style="filter: grayscale(100%); max-width: 100%">
      </router-link>
      <div class="footer-contacts">
        <div class="footer-contacts-wrapper">
          <div>
            <font-awesome-icon
              icon="fa-solid fa-location-dot"
              style="font-size: 16px; margin-left: auto"
            />
            <span style="margin-left: 10px">г. Мелитополь ул. Интеркультурная 77/4</span>
          </div>
          <div class="vertical-line" />
          <a href="https://t.me/tavriyapost">
            <img src="../assets/telega.svg" />
          </a>
        </div>
      </div>
    </div>
    <div class="container footer-policy-links">
      <a href="/cookie.pdf" class="footer-policy-link" target="_blank">Политика обработки cookie-файлов</a>
      <a href="/privacy_policy.pdf" class="footer-policy-link" target="_blank">Политика обработки персональных данных</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MainFooter',
}
</script>

<style scoped>
footer {
  background-color: var(--bg-1);
}
.container {
  width: 97%;
  max-width: 1240px;
  padding-top: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  row-gap: 10px;
  margin: auto;
  color: white;
}
.container > div:first-child {
  font-size: 16px;
  display: flex;
  align-items: center;
}
.container > div:first-child span {
  margin-top: 20px;
}
.footer-contacts-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  row-gap: 10px;
  font-size: 14px;
  margin-bottom: 10px;
}
.vertical-line {
  width: 0;
  margin: 0 15px;
}
.vertical-line:before {
  content: "";
  background: white;
  width: 1px;
  height: 32px;
  float: left;
  margin-right: 10px;
}
.footer-policy-links {
  padding-top: 10px;
  padding-bottom: 25px;
}
.footer-policy-link {
  color: white;
  text-decoration: underline;
  font-size: 14px;
  line-height: 16px;
  text-align: right;
  display: block;
}
@media screen and (max-width: 768px) {
  .container {
    flex-direction: column;
    justify-content: center;
  }
  .footer-contacts-wrapper {
    flex-direction: column;
  }
  .vertical-line, .vertical-line:before {
    display: none;
  }
}
</style>
